import { PortalLinkedItemType } from "../Enums/PortalLinkedItemType";
import { PortalSyncStatus } from "../Enums/PortalSyncStatus";
import { SharedItemPriority } from "./SharedItemPriority";

class SharedItemMessage {
    public SharedItemMessageId?: number;
    public SharedItemId: string;
    public Status: PortalSyncStatus;
    public CopiedFromId: string;
    public SentByContactId: string;
    public CreatedByUserId: string;
    public DateCreated: Date;
    public DateReadByUser: Date;
    public LastStatusDate: Date;
    public Text: string;
    public DateModified: Date;
    public ModifiedByUserId: string;
    public Priority?: SharedItemPriority;
    public IsFromPatient: boolean;
    public SharedItemSubject: string;
    public PatientFirstName?: string;
    public PatientLastName?: string;
    public PatientPreferredName?: string;

    // UI:
    public IsSelected: boolean;
    public IsDisabled: boolean;
    public MessageType: PortalLinkedItemType;
    public tmpIdForUI: string;

    constructor(fields?: Partial<SharedItemMessage>) {
        (Object as any).assign(this, fields);
        SharedItemMessage.init(this);
    }

    public static initAll(items: SharedItemMessage[]): void {
        items?.forEach(p => SharedItemMessage.init(p));
    }
    public static init(item: SharedItemMessage): void {
        if (!item)
            return;

        if (IsNullOrUndefined(item.IsSelected))
            item.IsSelected = [PortalSyncStatus.Pending, PortalSyncStatus.Viewed].contains(item.Status);
        item.tmpIdForUI = SharedItemMessage.getTempIdForUi(item);
    }

    public static getTempIdForUi(message: SharedItemMessage): string {
        if (!IsNullOrWhiteSpace(message.tmpIdForUI))
            return message.tmpIdForUI;

        return message.SharedItemMessageId
            ? message.SharedItemMessageId.toString()
            : `new${sessionStore.newId().toString()}`;
    }

    public static createNewSharedItemMessage(text: string, priority: SharedItemPriority = null): SharedItemMessage {
        return new SharedItemMessage({
            Text: text,
            Status: PortalSyncStatus.Unsent,
            SentByContactId: sessionStore.getCurrentEmployee().ContactId,
            CreatedByUserId: sessionStore.userId,
            Priority: priority,
            IsSelected: false,
            IsDisabled: false
        });
    }
}

export { SharedItemMessage };
